// extracted by mini-css-extract-plugin
module.exports = {"limitedText":"ReadFullNote_limitedText__3OeYr","overflowing":"ReadFullNote_overflowing__3-uz2"};